export default __webpack_public_path__ + "static/media/frame1.667e89c5.svg";